import { Button, Modal } from "antd";
import React, { useState } from "react";

export const GenericModal = ({ component, title, message, onOk, onCancel }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    onOk();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    if (onCancel) onCancel();
  };
  return (
    <>
      <div onClick={showModal}>{component}</div>
      <Modal
        title={title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>{message}</p>
      </Modal>
    </>
  );
};
